// Copyright (C) 2021 Bystronic Laser AG

import { ConsoleEnum } from './ConsoleEnum';

export enum AlertAction {
  None = 0,
  Web = 1,
  WebAndEmail = 2,
}

export enum WccAlertMetric {
  OEE = 1,
  LaserHealth = 2,
}

export enum CareAlertMetric {
  // Care: Health
  LowerProtectionGlass = 3,
  UpperProtectionGlass = 4,
  DrawerCycleTimes = 5,
  SpindleCurrent = 6, // UI: Lens drive
  Temperatures = 8,

  // Care: Events
  ErrorCount = 13, // UI: Errors
  WarningCount = 14, // UI: Warnings
  ErrorCountBySource = 15,
  WarningCountBySource = 16,

  // Care: Cutting Head
  DrawerChanges = 21, // UI: Drawer exchanges
  PDValues = 22, // UI: Diodes
  CuttingHeadTemperatures = 23,
  CuttingHeadDrawerCycleTimes = 26, // UI: Drawer cycles time

  // Care: Laser consumption
  UsedKWh = 24, // UI: Consumption in kWh
  UsedKWhOfMultiple = 25, // UI: Consumption in kWh per kW
}

export enum AlertOperator {
  GreaterThan = 1,
  LessThan = 2,
  Equal = 3,
}

/** @deprecated At the moment, always uses valueType like numeric */
export enum AlertValueType {
  Numeric = 1,
  String = 2,
}

export interface AlertKPI<
  T extends WccAlertMetric | CareAlertMetric = WccAlertMetric | CareAlertMetric,
> {
  /** @deprecated At the moment, always uses valueType like numeric */
  valueType: AlertValueType;
  kpi: T;
  console: ConsoleEnum;
  unit: string | null;
  variableValues: string[] | null;
}

export interface AlertKPIGroup<
  T extends WccAlertMetric | CareAlertMetric = WccAlertMetric | CareAlertMetric,
> {
  name: string;
  alertKpis: AlertKPI<T>[];
}

export enum AlertSeverity {
  Low = 1,
  Medium = 2,
  High = 3,
}
